<div class=" cdbg2">
  <div class=" cdbg2">
      <div class="helpdiv cdbg2">
          <div class="py-5 text-center container">
            <div class="row justify-content-center">
              <div class="col-10 col-lg-8">
                <h3 class="text-white mt-0">Cepetdapet Premium</h3>
                <h4 class="text-white">Jika Cepetdapet sudah bermanfaat untuk Anda dan ingin menggunakan lebih sering, maka kami menyediakan paket langganan dibawah ini. Sebelum kami menyediakan manfaat yang cukup, Anda selalu dapat menggunakan paket tidak berbayar.</h4>                
              </div>
            </div>
          </div>
      </div>
  </div>
</div>

<div class="divsubscription bg-white px-3">
  <div class="container-fluid">
    <div class="row g-0 justify-content-center py-3 py-lg-5">

      <div class="col-lg-2">

        <div class="boxSubsribtion parent d-none d-lg-block" tabindex="0">
          <table class="table align-middle table-striped rounded-0 card-content">
            <thead>
              <tr class="titleSub">
                <th colspan="2" class="cdbg1 text-white">Paket Cepetdapet</th>
              </tr>
              <tr>
                <th colspan="2">
                  <font class="pricing">Harga Paket (IDR)</font>
                </th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Partisipasi RFQ</p>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Analisa Pasar</p>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Produk Aktif</p>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Notifikasi Kecocokan RFQ</p>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Company Tag</p>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Jumlah User</p>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>Fitur Auto-bid</p>
                    </div>
                  </div>
                </td>
              </tr>

            </tbody>
          </table>

        </div>

      </div>

      <div class="col-lg-2" style="z-index: 10;">

        <div class=" pricing-card">
        <div class="ribbon-wrapper">
          <div class="ribbon">Daftar Sekarang</div>
        </div>


        <div class="boxSubsribtion card-content" tabindex="0">
          <table class="table align-middle table-striped rounded-0">
            <thead>
              <tr class="titleSub recommeded">
                <th colspan="2">Anggota Gratis</th>
              </tr>
              <tr>
                <th colspan="2">
                  <font class="pricing">Gratis</font> <font class="period"> /bulan</font>
                </th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">

                    <div class="col">
                      <p>5 RFQ per bulan</p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>2x analisa pasar per bulan</p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>10 produk aktif per bulan</p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>1x notifikasi per bulan</p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>5 company tag per periode</p>
                      
                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>2 user per periode</p>

                      
                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr style="background-color: #e9ecef;--bs-table-accent-bg:none;">
                <td colspan="2" style="background-color: #e9ecef;">
                  <p class="d-block d-lg-none m-0 pb-0">Fitur Auto-bid</p>
                  <p class="text-danger fw-bold">
                    Tidak tersedia
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <a href="/regis" class="subscribe-btn buttonSubs">Registrasi</a>
        </div>

        </div>
      </div>
      <div class="col-lg-2 pricing-card">

        <div class="boxSubsribtion card-content" tabindex="0">
          <table class="table align-middle table-striped rounded-0">
            <thead>
              <tr class="titleSub">
                <th colspan="2">Profesional</th>
              </tr>
              <tr>
                <th colspan="2">
                  <font class="pricing">399,000</font> <font class="period"> /bulan</font>
                </th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">

                    <div class="col">
                      <p>20 RFQ per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>2x analisa pasar per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>10 produk aktif per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>5x notifikasi per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>
                      
                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>5 company tag per periode <font class="fa fa-lock px-2" aria-hidden="true"></font></p>
                      

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>2 user per periode <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr style="background-color: #e9ecef;--bs-table-accent-bg:none;">
                <td colspan="2" style="background-color: #e9ecef;">
                  <p class="d-block d-lg-none m-0 pb-0">Fitur Auto-bid</p>
                  <p class="text-danger fw-bold">
                    Tidak tersedia
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="subscribe-btn" style="cursor:not-allowed;">
            <div class="text-center">
              <h1 class="fa fa-lock" aria-hidden="true" style="font-size: 100px;color:#cacaca;"></h1>
              <a class="btn buttonSubs disabled" style="width: 130px;">
                Segera Hadir</a>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-2 pricing-card">

        <div class="boxSubsribtion card-content" tabindex="0">
          <table class="table align-middle table-striped rounded-0">
            <thead>
              <tr class="titleSub">
                <th colspan="2">Bisnis</th>
              </tr>
              <tr>
                <th colspan="2">
                  <font class="pricing">1,000,000</font> <font class="period"> /bulan</font>
                </th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">

                    <div class="col">
                      <p>55 RFQ per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

                      
                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>


                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>6x analisa pasar per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment "></div>
                        <div class="gauge-segment "></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>


                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>20 produk aktif per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment "></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>


                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>20x notifikasi per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>5 company tag per periode <font class="fa fa-lock px-2" aria-hidden="true"></font></p>
                      

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                        <div class="gauge-segment"></div>
                      </div>


                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>2 user per periode <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment"></div>
                      </div>


                    </div>
                  </div>
                </td>
              </tr>

              <tr style="background-color: #e9ecef;--bs-table-accent-bg:none;">
                <td colspan="2" style="background-color: #e9ecef;">
                  <p class="d-block d-lg-none m-0 pb-0">Fitur Auto-bid</p>
                  <p class="text-danger fw-bold">
                    Tidak tersedia
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="subscribe-btn" style="cursor:not-allowed;">
            <div class="text-center">
              <h1 class="fa fa-lock" aria-hidden="true" style="font-size: 100px;color:#cacaca;"></h1>
              <a class="btn buttonSubs disabled" style="width: 130px;">
                Segera Hadir</a>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-2 pricing-card">

        <div class="boxSubsribtion card-content" tabindex="0">
          <table class="table align-middle table-striped rounded-0">
            <thead>
              <tr class="titleSub">
                <th colspan="2">Enterprise</th>
              </tr>
              <tr>
                <th colspan="2">
                  <font class="pricing">3,500,000</font> <font class="period"> /bulan</font>
                </th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">

                    <div class="col">
                      <p>200 RFQ per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

                      
                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>150x analisa pasar per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>60 produk aktif per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>

    
                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>60x notifikasi per bulan <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>10 company tag per periode <font class="fa fa-lock px-2" aria-hidden="true"></font></p>
                      

                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div class="row g-1 align-items-start">
                    <div class="col">
                      <p>3 user per periode <font class="fa fa-lock px-2" aria-hidden="true"></font></p>


                      <div class="gauge-bar d-flex">
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                        <div class="gauge-segment filled"></div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>

              <tr style="background-color: #e9ecef;--bs-table-accent-bg:none;">
                <td colspan="2" style="background-color: #e9ecef;">
                  <p class="d-block d-lg-none m-0 pb-0">Fitur Auto-bid</p>
                  <p class="text-success fw-bold">
                    Tersedia
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="subscribe-btn" style="cursor:not-allowed;">
            <div class="text-center">
              <h1 class="fa fa-lock" aria-hidden="true" style="font-size: 100px;color:#cacaca;"></h1>
              <a class="btn buttonSubs disabled" style="width: 130px;">
                Segera Hadir</a>
            </div>
          </div>
        </div>

      </div>

    </div>


    <!-- <div class="pricing-card" tabindex="0">
      <div class="card-content">
        <h3>Pro Plan</h3>
        <p>$19/month</p>
      </div>
      <button class="subscribe-btn">Subscribe</button>
    </div> -->
    

  </div>
</div>

<section id="subscription"  class="sectionpricing py-5 d-none">
	<div class="main-container pb-3">
		<div class="text-center titlepricing p-5">
			<h2 class="">CepetDapet <font style="color:#007cc2;">Premium</font></h2>
				<h4 class="m-0">Jika Cepetdapet sudah bermanfaat untuk Anda dan Anda ingin menggunakan lebih sering, maka kami menyediakan paket langganan dibawah ini.
          Sebelum kami menyediakan manfaat yang cukup, Anda selalu dapat menggunakan paket tidak berbayar.</h4>
		</div>
    <div class="">
      <div class="Product-PricePlan-Board mb-4">
        <div class="row">
          <div class="col-sm-3">
            <div class="d-flex align-items-center justify-content-center h-100">
              <span class="Introduction-Period py-3">
                Introduction Period
              </span>
            </div>
          </div>
          <div class="col-sm-6 p-3 borderBoard">
            <div class="list-PricePlan container">
              <div class="row">
                <div class="col-12">
                  <p class="titlePlan">
                    Benefit paket:
                  </p>
                </div>
                <div class="col-sm-6 px-2">
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Participate in RFQ Tanpa Batas</p>
                  </div>

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Market Intelligent 2/bulan</p>
                  </div>                 

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">10 Active Products</p>
                  </div>     
                  
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">RFQ Match Notification 100/bulan</p>
                  </div>               
                  
                  
                </div>
                <div class="col-sm-6 px-2">

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Business Tag 5</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Users 2</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-2-base.png">
                    <p class="textPlan mb-2 ps-2">Autobid</p>
                  </div>  
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 p-3">
            <div class="d-flex align-items-end justify-content-center h-100">
              <div class="w-100 pb-3 pe-0 pe-sm-5">
                <h3 class="actionTitle m-0 pt-3">Free</h3>
                <p class="actionDesc m-0 pt-0 pb-3">Per Bulan</p>
                <a class="btn btn-fluid w-100 btn-primary actionBtn text-white m-0 mb-3" href="/regis">Register</a>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="Product-PricePlan-Board mb-4">
        <div class="row">
          <div class="col-sm-3">
            <div class="d-flex align-items-center justify-content-center h-100">
              <span class="Introduction-Period py-3">
                Free member
              </span>
            </div>
          </div>
          <div class="col-sm-6 p-3 borderBoard">
            <div class="list-PricePlan container">
              <div class="row">
                <div class="col-12">
                  <p class="titlePlan">
                    Benefit paket:
                  </p>
                </div>
                <div class="col-sm-6 px-2">
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Participate in RFQ 5/bulan</p>
                  </div>

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Market Intelligent 2/bulan</p>
                  </div>                 

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">10 Active Products</p>
                  </div>     
                  
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">RFQ Match Notification 1/bulan</p>
                  </div>               
                  
                  
                </div>
                <div class="col-sm-6 px-2">

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Business Tag 5</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Users 2</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-2-base.png">
                    <p class="textPlan mb-2 ps-2">Autobid</p>
                  </div>  
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 p-3">
            <div class="d-flex align-items-end justify-content-center h-100">
              <div class="w-100 pb-3 pe-0 pe-sm-5">
                <h3 class="actionTitle m-0 pt-3">Free</h3>
                <p class="actionDesc m-0 pt-0 pb-3">Per Bulan</p>
                <a class="btn btn-fluid w-100 btn-primary actionBtn text-white m-0 mb-3 disabled">Coming Soon</a>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="Product-PricePlan-Board mb-4">
        <div class="row">
          <div class="col-sm-3">
            <div class="d-flex align-items-center justify-content-center h-100">
              <span class="Introduction-Period py-3">
                Professional
              </span>
            </div>
          </div>
          <div class="col-sm-6 p-3 borderBoard">
            <div class="list-PricePlan container">
              <div class="row">
                <div class="col-12">
                  <p class="titlePlan">
                    Benefit paket:
                  </p>
                </div>
                <div class="col-sm-6 px-2">
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Participate in RFQ 20/bulan</p>
                  </div>

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Market Intelligent 2/bulan</p>
                  </div>                 

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">10 Active Products</p>
                  </div>     
                  
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">RFQ Match Notification 5/bulan</p>
                  </div>               
                  
                  
                </div>
                <div class="col-sm-6 px-2">

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Business Tag 5</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Users 2</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-2-base.png">
                    <p class="textPlan mb-2 ps-2">Autobid</p>
                  </div>  
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 p-3">
            <div class="d-flex align-items-end justify-content-center h-100">
              <div class="w-100 pb-3 pe-0 pe-sm-5">
                <h3 class="actionTitle m-0 pt-3">IDR 399,000</h3>
                <p class="actionDesc m-0 pt-0 pb-3">Per Bulan</p>
                <a class="btn btn-fluid w-100 btn-primary actionBtn text-white m-0 mb-3 disabled">Coming Soon</a>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="Product-PricePlan-Board mb-4">
        <div class="row">
          <div class="col-sm-3">
            <div class="d-flex align-items-center justify-content-center h-100">
              <span class="Introduction-Period py-3">
                Business
              </span>
            </div>
          </div>
          <div class="col-sm-6 p-3 borderBoard">
            <div class="list-PricePlan container">
              <div class="row">
                <div class="col-12">
                  <p class="titlePlan">
                    Benefit paket:
                  </p>
                </div>
                <div class="col-sm-6 px-2">
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Participate in RFQ 55/bulan</p>
                  </div>

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Market Intelligent 6/bulan</p>
                  </div>                 

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">20 Active Products</p>
                  </div>     
                  
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">RFQ Match Notification 20/bulan</p>
                  </div>               
                  
                  
                </div>
                <div class="col-sm-6 px-2">

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Business Tag 5</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Users 2</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-2-base.png">
                    <p class="textPlan mb-2 ps-2">Autobid</p>
                  </div>  
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 p-3">
            <div class="d-flex align-items-end justify-content-center h-100">
              <div class="w-100 pb-3 pe-0 pe-sm-5">
                <h3 class="actionTitle m-0 pt-3">IDR 1,000,000</h3>
                <p class="actionDesc m-0 pt-0 pb-3">Per Bulan</p>
                <a class="btn btn-fluid w-100 btn-primary actionBtn text-white m-0 mb-3 disabled">Coming Soon</a>
              </div>

            </div>

          </div>
        </div>

      </div>



      <div class="Product-PricePlan-Board mb-4">
        <div class="row">
          <div class="col-sm-3">
            <div class="d-flex align-items-center justify-content-center h-100">
              <span class="Introduction-Period py-3">
                SME
              </span>
            </div>
          </div>
          <div class="col-sm-6 p-3 borderBoard">
            <div class="list-PricePlan container">
              <div class="row">
                <div class="col-12">
                  <p class="titlePlan">
                    Benefit paket:
                  </p>
                </div>
                <div class="col-sm-6 px-2">
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Participate in RFQ 200/bulan</p>
                  </div>

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Market Intelligent 150/bulan</p>
                  </div>                 

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">50 Active Products</p>
                  </div>     
                  
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">RFQ Match Notification 60/bulan</p>
                  </div>               
                  
                  
                </div>
                <div class="col-sm-6 px-2">

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Business Tag 10</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Users 3</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Autobid</p>
                  </div>  
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 p-3">
            <div class="d-flex align-items-end justify-content-center h-100">
              <div class="w-100 pb-3 pe-0 pe-sm-5">
                <h3 class="actionTitle m-0 pt-3">IDR 3,500,000</h3>
                <p class="actionDesc m-0 pt-0 pb-3">Per Bulan</p>
                <a class="btn btn-fluid w-100 btn-primary actionBtn text-white m-0 mb-3 disabled">Coming Soon</a>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="Product-PricePlan-Board mb-4">
        <div class="row">
          <div class="col-sm-3">
            <div class="d-flex align-items-center justify-content-center h-100">
              <span class="Introduction-Period py-3">
                Corporate
              </span>
            </div>
          </div>
          <div class="col-sm-6 p-3 borderBoard">
            <div class="list-PricePlan container">
              <div class="row">
                <div class="col-12">
                  <p class="titlePlan">
                    Benefit paket:
                  </p>
                </div>
                <div class="col-sm-6 px-2">
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Participate in RFQ 400/bulan</p>
                  </div>

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Market Intelligent 400/bulan</p>
                  </div>                 

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">100 Active Products</p>
                  </div>     
                  
                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">RFQ Match Notification 200/bulan</p>
                  </div>               
                  
                  
                </div>
                <div class="col-sm-6 px-2">

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Business Tag 15</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Users 5</p>
                  </div>  

                  <div class="d-flex align-items-center">
                    <img style="max-width: 24px;" src="/assets/images/icons/Group 518-base.png">
                    <p class="textPlan mb-2 ps-2">Autobid</p>
                  </div>  
                  
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 p-3">
            <div class="d-flex align-items-end justify-content-center h-100">
              <div class="w-100 pb-3 pe-0 pe-sm-5">
                <h3 class="actionTitle m-0 pt-3">IDR 6,250,000</h3>
                <p class="actionDesc m-0 pt-0 pb-3">Per Bulan</p>
                <a class="btn btn-fluid w-100 btn-primary actionBtn text-white m-0 mb-3 disabled">Coming Soon</a>
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>
		<div class="py-5 d-none">
			<div class="table-responsive divpricing shadow">
				<table class="table align-middle tablepricing">
					<thead>
						<tr class="thpricing">
							<th>
								<h3 class="my-3">Penawaran Fitur</h3>
							</th>
							<th>
								<h5 class="mb-0">Introduction Period *</h5>
								<h3 class="mb-0">Gratis *</h3>
								<p class="mb-0">per month</p>
							</th>
							<th>
								<h5 class="mb-0">Free Member</h5>
								<h3 class="mb-0">Gratis</h3>
								<p class="mb-0">per month</p>
							</th>
							<th>
								<h5 class="mb-0">Professional</h5>
								<h3 class="mb-0">Coming Soon</h3>
								<p class="mb-0">per month</p>
							</th>
							<th>
								<h5 class="mb-0">Business</h5>
								<h3 class="mb-0">Coming Soon</h3>
								<p class="mb-0">per month</p>
							</th>
							<th>
								<h5 class="mb-0">SME</h5>
								<h3 class="mb-0">Coming Soon</h3>
								<p class="mb-0">per month</p>
							</th>
							<th>
								<h5 class="mb-0">Corporate</h5>
								<h3 class="mb-0">Coming Soon</h3>
								<p class="mb-0">per month</p>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Paticipate in RFQ</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> Tanpa Batas</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 20/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 55/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 200/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 400/bulan</td>
						</tr>
						<tr>
							<td>Market Intelligent</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 6/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 150/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 400/bulan</td>
						</tr>
						<tr>
							<td>Active Product</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 10/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 10/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 10/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 20/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 50/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 100/periode</td>
						</tr>
						<tr>
							<td>RFQ Match Notification</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 100/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 1/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 20/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 60/bulan</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 200/bulan</td>
						</tr>
						<tr>
							<td>Business Tag</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 10/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 15/periode</td>
						</tr>
						<tr>
							<td>Users</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 2/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 3/periode</td>
							<td><i class="bi bi-check-circle-fill text-success"></i> 5/periode</td>
						</tr>
						<tr>
							<td>Autobid</td>
							<td><i class="bi bi-x-circle-fill text-danger"></i></td>
							<td><i class="bi bi-x-circle-fill text-danger"></i></td>
							<td><i class="bi bi-x-circle-fill text-danger"></i></td>
							<td><i class="bi bi-x-circle-fill text-danger"></i></td>
							<td><i class="bi bi-check-circle-fill text-success"></i></td>
							<td><i class="bi bi-check-circle-fill text-success"></i></td>
						</tr>
					</tbody>

					<!-- Partisipasi RFQ
					
					
					
					
					
					
	
					<td><i class="bi bi-check-circle-fill text-success"></i> 2/bulan</td>
					<td><i class="bi bi-check-circle-fill text-success"></i> 10/periode</td>
					<td><i class="bi bi-check-circle-fill text-success"></i> 100/bulan</td>
					<td><i class="bi bi-check-circle-fill text-success"></i> 5/periode</td>
					<td><i class="bi bi-check-circle-fill text-success"></i> 2/periode</td>
					<td><i class="bi bi-x-circle-fill text-danger"></i></td> -->
	
	
				</table>
			</div>
		</div>

	</div>
</section>